/**
 * 通知 API 模块
 * FR-NOTIFY-02: 30s 轮询精确未读数
 */
import { get, request, put } from '@/api/client'

/** 获取未读数量；includeBreakdown 为 true 时请求服务端分类统计能力。 */
export function getUnreadCount(includeBreakdown = false) {
  return get<NotificationUnreadRes>(
    `/business/notification/getUnreadCount${includeBreakdown ? '?includeBreakdown=true' : ''}`,
  )
}

/** 获取通知列表 */
export function getNotificationList(params: NotificationListParams) {
  return request<{ list: AppNotification[]; total: number }>(
    '/business/notification/getNotificationList',
    {
      method: 'POST',
      body: params,
    },
  )
}

/** 按需获取单条通知完整正文 */
export function getNotificationContent(id: number) {
  return request<NotificationContentRes>('/business/notification/getNotificationContent', {
    method: 'POST',
    body: { id },
  })
}

/** 标记单条为已读 */
export function markAsRead(id: number) {
  return put<null>('/business/notification/markAsRead', { id })
}

/** 标记全部已读 */
export function markAllAsRead() {
  return put<null>('/business/notification/markAllAsRead')
}
